var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1851 5109 c-657 -74 -1219 -432 -1555 -989 -138 -229 -223 -463 -273 -745 -26 -151 -23 -500 5 -655 120 -657 508 -1187 1087 -1487 310 -160 591 -228 945 -227 431 0 785 107 1145 345 l119 79 696 -693 c469 -468 708 -700 735 -713 54 -25 167 -25 215 0 120 63 175 193 135 317 -17 51 -54 91 -717 755 l-699 701 77 114 c371 548 453 1234 222 1869 -75 208 -219 450 -375 631 -260 300 -628 533 -1005 634 -230 62 -542 89 -757 64z m357 -510 c380 -41 677 -182 943 -448 271 -271 415 -579 451 -963 32 -343 -60 -693 -263 -998 -84 -127 -282 -325 -409 -409 -512 -341 -1143 -359 -1664 -47 -376 224 -641 602 -728 1039 -32 160 -32 414 0 574 90 451 367 835 767 1062 267 152 604 223 903 190z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.699b1e7e5caab1d59a9312871a9aa838.svg";
export { ForwardRef as ReactComponent };